import { createSelector } from '@ngrx/store';
import { Record } from 'immutable';
import { configuration_DEPRECATED } from 'src/app/app.config';
import { VehicleStatus } from 'src/graphql/generated/graphql.generated';
import {
  selectAllVehicleDispositions,
  selectAllVehicles,
} from 'src/store/entityStores/entity-store-selectors';
import { selectUnitSummariesByCompanyId } from 'src/store/entityStores/unit-selectors';
import { selectPositionReportAlertEntitiesByCompanyId } from 'src/store/generated/position-report-alert-record.generated';
import { selectVehicleSummaryEntitiesByCompanyId } from 'src/store/generated/vehicle-summary-record.generated';

const pastDueInMinutes = configuration_DEPRECATED.operations.positionAlertTimeoutInMinutes;

export class PositionReportAlertViewModelRecord extends Record({
  unitId: null as any,
  unitAbbreviation: null as any,
}) {
  constructor(params: { unitId: string; unitAbbreviation: string }) {
    super(params);
  }
}

export function selectAllVehiclesAndDispositions() {
  return createSelector(
    selectAllVehicles,
    selectAllVehicleDispositions,
    (vehicles, vehicleDispositions) => ({ vehicles, vehicleDispositions }),
  );
}

export function selectPositionReportAlerts(companyId: string) {
  return createSelector(
    selectPositionReportAlertEntitiesByCompanyId(companyId),
    selectVehicleSummaryEntitiesByCompanyId(companyId),
    selectUnitSummariesByCompanyId(companyId),
    (alerts, vehicles, units) => {
      return (
        alerts
          .valueSeq()
          .filter(
            (positionReportAlertRecord) =>
              positionReportAlertRecord.hasReceivedQualifyingReport === false &&
              vehicles.find((v) => v.id === positionReportAlertRecord.vehicleId)?.status ===
                VehicleStatus.EnRoute,
          )
          .map((positionReportAlertRecord) => {
            const vehicle = vehicles.find((v) => v.id === positionReportAlertRecord.vehicleId);
            const unit = units.find((u) => u.id === vehicle?.unitId);
            return unit == null
              ? null
              : new PositionReportAlertViewModelRecord({
                  unitId: unit.id,
                  unitAbbreviation: unit.abbreviation,
                });
          })
          .filter((model) => model != null)
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          .map((model) => model!)
          .toIndexedSeq()
      );
    },
  );
}
